import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "external-window",
  "use": "external-window-usage",
  "viewBox": "0 0 192 192",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 192 192\" id=\"external-window\"><title>ic-external-window</title><g id=\"external-window_external_window\" data-name=\"external window\"><g id=\"external-window_expanded-2\" data-name=\"expanded\"><path d=\"M160,39.21c0-.11,0-.21-.05-.32s0-.31-.07-.46-.06-.24-.09-.37-.06-.26-.1-.39-.08-.24-.12-.36-.09-.25-.14-.37-.1-.22-.15-.33-.12-.26-.19-.38a2.91,2.91,0,0,0-.17-.3l-.23-.37a3.71,3.71,0,0,0-.23-.32l-.23-.31a5.91,5.91,0,0,0-.48-.52l-.05-.07,0,0c-.17-.17-.35-.33-.54-.49l-.29-.21-.34-.25c-.11-.08-.23-.14-.34-.21l-.33-.2-.36-.17-.35-.16-.35-.13-.39-.14-.34-.08-.42-.11-.39-.06-.38-.05-.7,0H104a8,8,0,0,0,0,16h28.69L74.34,106.34a8,8,0,0,0,11.32,11.32L144,59.31V88a8,8,0,0,0,16,0V40A7,7,0,0,0,160,39.21Z\" /><path d=\"M152,112a8,8,0,0,0-8,8v24H48V48H72a8,8,0,0,0,0-16H40a8,8,0,0,0-8,8V152a8,8,0,0,0,8,8H152a8,8,0,0,0,8-8V120A8,8,0,0,0,152,112Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/external-window.svg
// module id = 1857
// module chunks = 0